/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import React from "react";
import {TFacet} from "@/app/types/TFacet";
import {useClearRefinements, useCurrentRefinements} from "react-instantsearch";
import {useTranslation} from "next-i18next";
import WidgetBox from "@/app/components/sidebar/WidgetBox";
import classes from "@/app/components/sidebar/FiltersActive/styles.module.scss";
import {Button} from "@mui/material";
import CloseButton from "@/app/components/assets/common/CloseButton";

const FacetsActive = (props: {
    facetsConfig: TFacet[],
    collapsibleOnMobile?: boolean,
    className?: string,
}) => {
    const {t} = useTranslation();
    const classesAdditional = props.className ?? '';
    const { canRefine, refine:clearRefine } = useClearRefinements();
    const {items, refine} = useCurrentRefinements();

    if (items.length > 0) {
        return <WidgetBox
            heading={<span>{t('Now Shopping by')} <b>{`(${items.length})`}</b></span>}
            collapsibleOnMobile={props.collapsibleOnMobile}
            variant={'default'}
            className={classesAdditional}>
            <div className={classes.list}>
                {items.map((item) => {
                    const currentFacet = props.facetsConfig.filter((facet) => item.label === facet.attribute);
                    const label = currentFacet.length > 0 ? currentFacet[0].label : '';
                    return <React.Fragment key={`${item.attribute}`}>
                        {item.refinements.map((refinement) => {
                            let refinementLabel = refinement.label;
                            if(refinement.attribute === 'in_stock') {
                                refinementLabel = refinement.label == "1" || refinement.label == "true"
                                    ? t('In stock')
                                    : refinement.label == "false" || refinement.label == "0"
                                        ? t("Out of stock")
                                        : item.label
                            }
                            return <Button variant="text" data-theme-styles="false"
                                           key={[refinement.attribute, refinement.value].join('/')}
                                           className={`${classes['btn']}`}
                                           onClick={(event) => {
                                               if (isModifierClick(event)) {return}
                                               refine(refinement);
                                           }}
                            >
                                <span className={`${classes['category']}`}>{label}:</span>
                                {refinement.attribute === 'availability' &&
                                    <span className={`${classes['value']}`}>{t('In stock ')}
                                        <span style={{textTransform: 'lowercase'}}>{t('at ')}</span>
                                        {refinementLabel}<CloseButton/>
                                    </span>}
                                {refinement.attribute !== 'availability' &&
                                    <span className={`${classes['value']}`}>{refinementLabel}<CloseButton/></span>}
                            </Button>;
                        })}</React.Fragment>;
                })}
                <Button variant="text" onClick={clearRefine} className={`${classes['clear']} ${classes['btn']}`}>
                    {t("Clear all")}
                </Button>
            </div>
        </WidgetBox>;
    }

    return <></>;
}

const isModifierClick = (event: any) => {
    const isMiddleClick = event.button === 1;

    return Boolean(
        isMiddleClick ||
        event.altKey ||
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey
    );
}

export default FacetsActive;
